export default function creditsafeCompanySearchInput() {
	const searchBarCreditsafeInput = document.getElementById(
		'searchBarCreditsafe',
	);
	const submitButton = document.getElementById('submitCompanySearchButton');
	const foundCompanyContainer = document.getElementById(
		'foundCompanyContainer',
	);
	const foundCompanyContainerItemsElem = document.getElementById(
		'foundCompanyContainerItems',
	);
	const radioButtonsContainer = document.getElementById(
		'radioButtonsContainer',
	);
	const noResultsMsg = document.getElementById('creditsafeNoResultsMsg');
	const errorMsg = document.getElementById('creditsafeErrorMsg');

	if (
		!searchBarCreditsafeInput ||
		!foundCompanyContainer ||
		!foundCompanyContainerItemsElem ||
		!radioButtonsContainer
	) {
		return;
	}

	const radioButtons = radioButtonsContainer.querySelectorAll(
		'input[type="radio"]',
	);

	let companiesList = [];

	function debounce(func, delay) {
		let timeoutId;
		return function (...args) {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	foundCompanyContainer.addEventListener(
		'click',
		handleBillingAddressFormClick,
	);

	function resetDropdown() {
		foundCompanyContainerItemsElem.innerHTML = '';
		foundCompanyContainerItemsElem.setAttribute('hidden', '');
		noResultsMsg?.setAttribute('hidden', '');
		errorMsg?.setAttribute('hidden', '');
	}

	function renderCompaniesList(companies, searchTerm) {
		companiesList = companies || [];

		const searchMatchRegexp = createSearchMatchRegexp(searchTerm);

		foundCompanyContainerItemsElem.innerHTML = companies
			.map(company => {
				const { creditCheckedCompanyId, companyLine } =
					formatCompanyLine(company);
				const highlightedCompanyLine = searchMatchRegexp
					? highlightSearchMatches(companyLine, searchMatchRegexp)
					: companyLine;
				return renderCompanyItem(
					creditCheckedCompanyId,
					highlightedCompanyLine,
				);
			})
			.join('');

		noResultsMsg?.setAttribute('hidden', '');
		errorMsg?.setAttribute('hidden', '');
		foundCompanyContainerItemsElem.removeAttribute('hidden');

		foundCompanyContainer.removeAttribute('hidden');
	}

	function renderCompanyItem(creditCheckedCompanyId, companyLine) {
		return `<p data-credit-checked-company-id="${creditCheckedCompanyId}" class="creditsafe-company-search__company-item" translate="no">${companyLine}</p>`;
	}

	function createSearchMatchRegexp(searchTerm) {
		const tokens = searchTerm
			.trim()
			.split(/\s+/)
			.filter(Boolean)
			.map(escapeRegExp);

		if (!tokens.length) return null;

		return new RegExp(`(${tokens.join('|')})`, 'gi');
	}

	function escapeRegExp(value) {
		return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	function handleBillingAddressFormClick({ target }) {
		const companyItem = target?.closest('[data-credit-checked-company-id]');

		if (!companyItem) return;

		const { creditCheckedCompanyId } = companyItem.dataset || {};
		showBillingAddressForm(creditCheckedCompanyId);
	}

	function showBillingAddressForm(creditCheckedCompanyId) {
		if (!creditCheckedCompanyId) return;

		const selectedCompany = companiesList.find(
			company => company.creditCheckedCompanyId === creditCheckedCompanyId,
		);

		const creditsafeCompanySearchForm = document.getElementById(
			'creditsafeCompanySearchForm',
		);

		if (creditsafeCompanySearchForm && selectedCompany) {
			const showBillingAddressFormEvent = new CustomEvent(
				'show-billing-address-form',
				{ detail: selectedCompany },
			);
			creditsafeCompanySearchForm.dispatchEvent(showBillingAddressFormEvent);
		}
	}

	function formatCompanyLine(company) {
		const {
			companyName,
			postalCode,
			town,
			streetNumber,
			streetName,
			chamberOfCommerceId,
			creditCheckedCompanyId,
		} = company;
		const streetInfo = streetNumber
			? `${streetName}, ${streetNumber}`
			: streetName;
		const chamberInfoText = chamberOfCommerceId
			? `, ${chamberOfCommerceId}`
			: '';

		// prettier-ignore
		const companyLine = `${companyName || ''}${chamberInfoText} ${streetInfo || ''}, ${town || ''}, ${postalCode || ''}`
		return { creditCheckedCompanyId, companyLine };
	}

	function highlightSearchMatches(companyLine, searchMatchRegexp) {
		return companyLine.replace(searchMatchRegexp, '<b>$1</b>');
	}

	function hideFoundCompanies() {
		foundCompanyContainer.setAttribute('hidden', '');
		resetDropdown();
	}

	function searchCompany({ searchTerm, searchBy }) {
		resetDropdown();

		fetch(
			`ajax/creditsafe/company/search?searchBy=${searchBy}&searchTerm=${encodeURIComponent(searchTerm)}`,
		)
			.then(response => response.json())
			.then(response => {
				if (response?.status === 'ERROR') {
					errorMsg?.removeAttribute('hidden');
					foundCompanyContainer.removeAttribute('hidden');
				} else {
					const companies = response?.data?.companies || [];

					if (companies.length) {
						renderCompaniesList(companies, searchTerm);
					} else {
						noResultsMsg?.removeAttribute('hidden');
						foundCompanyContainer.removeAttribute('hidden');
					}
				}
			})
			.catch(() => {
				errorMsg?.removeAttribute('hidden');
				foundCompanyContainer.removeAttribute('hidden');
			});
	}

	function onSubmit(event) {
		event.preventDefault();
		const value = getValue();
		if (value) searchCompany(value);
	}

	function onInput(event) {
		event.preventDefault();
		const value = getValue();
		if (!value || value.searchBy === 'NUMBER') return;
		searchCompany(value);
	}

	function getValue() {
		const searchTerm = searchBarCreditsafeInput.value;
		if (!searchTerm) {
			hideFoundCompanies();
			return undefined;
		}

		const selectedRadio = [...(radioButtons || [])].find(
			radioButton => radioButton.checked,
		);

		if (!selectedRadio) return undefined;

		return { searchTerm, searchBy: selectedRadio.value.toUpperCase() };
	}

	if (submitButton) {
		submitButton.addEventListener('click', onSubmit);
	}

	searchBarCreditsafeInput.addEventListener('input', debounce(onInput, 1000));
}
